module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "flow-area white-background",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "group": "elements",
      "handle": ".drag-handle",
      "animation": 350
    },
    on: {
      "end": _vm.moved
    },
    model: {
      value: (_vm.flow.steps),
      callback: function($$v) {
        _vm.$set(_vm.flow, "steps", $$v)
      },
      expression: "flow.steps"
    }
  }, _vm._l((_vm.flow.steps), function(step) {
    return _c('div', {
      key: step._id,
      on: {
        "keydown": function($event) {
          $event.stopPropagation();
          return _vm.keyPressed($event, step)
        }
      }
    }, [_c('Step', {
      ref: ("step" + (step._id)),
      refInFor: true,
      attrs: {
        "step": step,
        "level": _vm.level
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79cb042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/Flow.vue
// module id = 2657
// module chunks = 1